import { isInternalUser } from "common/MetaActions";
import { MessageItem, Thread } from "models/inbox/inbox";

export function filterAndSortMessages(messages: MessageItem[]) {
  const isInternal = isInternalUser();

  const visibleMessages = messages.filter((msg: MessageItem) => {
    if (msg.isDeleted) {
      return false;
    }
    if (!isInternal && msg.isHidden) {
      return false;
    }
    return true;
  });

  const sorted = visibleMessages
    .slice()
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

  const hasVisibleMessages = sorted.length > 0;

  return {
    messages: sorted,
    hasVisibleMessages
  };
}

export function sortThreadsByLastMessage(threads: Thread[]): Thread[] {
  return [...threads].sort((a, b) => {
    const aTime = new Date(a.lastMessage?.createdAt ?? 0).getTime();
    const bTime = new Date(b.lastMessage?.createdAt ?? 0).getTime();
    return bTime - aTime;
  });
}
